import { DropdownList, NavList } from '@cpm-pr1618001/ng-design-lib';
import { HttpRequestStatus } from '@cpm-pr1618003/ng-initializer-lib';
import { UserDialogView } from 'src/app/landing-page/landing-page.modal';
import {
  DESKTOP_NAVIGATION_MENU,
  MOBILE_NAVIGATION_MENU,
} from '../../header/mobile-menu-navigation-list.constants';

export interface LandingPage {
  activeSignButton: UserDialogView;
  signInDetails: SignInDetails;
  signUpDetails: SignUpDetails;
  fpDetails: FPDetails;
  signInResponse: SignInResponse;
  signUpResponse: SignUpResponse;
  isPasswordUpdated: boolean;
  isOTPRequested: boolean;
  isOTPSent: boolean;
  reactivateKey: string | null;
  reactivateAccountResponse: LandingHttpResponse | null;
  reactivateAccountRequestStatus: HttpRequestStatus;
  reactivateAccountErrorMessage: string | null;
  contactUsResponse: ContactUsResponse;
  contactUsRequestStatus: HttpRequestStatus;
  signInRequestStatus: HttpRequestStatus;
  signUpRequestStatus: HttpRequestStatus;
  requestOTPRequestStatus: HttpRequestStatus;
  changePasswordRequestStatus: HttpRequestStatus;
  mobileNavigationMenu: DropdownList[];
  desktopNavigationMenu: NavList[];
}

export interface SignUpResponse {
  status: number;
  message: string;
  error: string;
}

export interface PyResponse {
  status: number;
  message: string;
  error: string;
}

export interface FPDetails {
  emailId: string;
  newPassword: string;
  otp: string;
}

export interface SignInDetails {
  email: string;
  password: string;
  rememberMe: boolean;
}

export interface SignUpDetails {
  firstName: string;
  lastName: string;
  emailId: string;
  phoneNumber: string;
  password: string;
  confirmPassword?: string;
  country: string;
  country_code: string;
  state: string;
  zip: string;
  isAgreementAndPrivacyAgreed: boolean;
  zip_ext?: string;
  addressLine1?: string;
  addressLine2?: string;
}

export interface SignInPayload {
  userId: string;
  password: string;
}

export interface SignInResponse {
  userId: string;
}

export interface LandingHttpResponse {
  status: number;
  message: string;
  error: string;
}

export interface ContactUsDetails {
  firstName: string;
  lastName: string;
  emailAddress: string;
  helpTextField: string;
  website?: string;
  countryCodeIso2: string;
}

export interface ContactUsResponse {
  status: number;
  message: string;
  error: string;
}

export const initialState: LandingPage = {
  activeSignButton: UserDialogView.CLOSE,
  signInDetails: null,
  signUpDetails: null,
  fpDetails: null,
  signInResponse: null,
  signUpResponse: null,
  isPasswordUpdated: false,
  isOTPRequested: false,
  isOTPSent: false,
  reactivateKey: null,
  reactivateAccountResponse: null,
  reactivateAccountRequestStatus: HttpRequestStatus.Idle,
  reactivateAccountErrorMessage: null,
  contactUsResponse: null,
  contactUsRequestStatus: HttpRequestStatus.Idle,
  signInRequestStatus: HttpRequestStatus.Idle,
  signUpRequestStatus: HttpRequestStatus.Idle,
  requestOTPRequestStatus: HttpRequestStatus.Idle,
  changePasswordRequestStatus: HttpRequestStatus.Idle,
  mobileNavigationMenu: MOBILE_NAVIGATION_MENU,
  desktopNavigationMenu: DESKTOP_NAVIGATION_MENU,
};

export interface LandingPageState {
  landingPageState: LandingPage;
}
